
import salesExecution from "./salesExecution";

export const portLogin_sideBarItems = [
    salesExecution,
];


// WEBPACK FOOTER //
// ./src/sidebar/port_index.js